import * as types from "../actions/actionTypes";
import { TagNames } from "../../lib/constants";

const initialState = {
  currencyConversionRate: {
    loading: false,
    success: true
  },
  fromEmailAddress:{
    loading: false,
    success: true
  },
  signatures: {
    loading: false,
    success: true
  },
  returnAddress: {
    loading: false,
    success: true
  },
  individualTags: {
    add: {
      loading: false,
      success: true
    },
    delete: {}
  },
  organizationTags: {
    add: {
      loading: false,
      success: true
    },
    delete: {}
  },
  individualApplicationReasons: {
    add: {
      loading: false,
      success: true
    },
    delete: {}
  },
  organizationApplicationReasons: {
    add: {
      loading: false,
      success: true
    },
    delete: {}
  },
  usPersonTitles: {
    add: {
      loading: false,
      success: true
    },
    delete: {},
    update: {
      loading: false,
      success: true
    }
  },
  israelPersonTitles: {
    add: {
      loading: false,
      success: true
    },
    delete: {},
    update: {
      loading: false,
      success: true
    }
  },
  usInstitutionTitles: {
    add: {
      loading: false,
      success: true
    },
    delete: {},
    update: {
      loading: false,
      success: true
    }
  },
  israelInstitutionTitles: {
    add: {
      loading: false,
      success: true
    },
    delete: {},
    update: {
      loading: false,
      success: true
    }
  },
  campaignCategories: {
    add: {
      loading: false,
      success: true
    },
    delete: {}
  },
  campaignIndivCategories: {
    add: {
      loading: false,
      success: true
    },
    delete: {}
  },
  campaignLocationGroups: {
    add: {
      loading: false,
      success: true
    },
    update: {
      loading: false,
      success: true
    },
    delete: {}
  },
  defaultUSFund: {
    loading: false,
    success: true
  },
  defaultIsraelFund: {
    loading: false,
    success: true
  },
  depositSources: {
    add: {
      loading: false,
      success: true
    },
    update: {
      loading: false,
      success: true
    }
  },
  withdrawalTypes: {
    add: {
      loading: false,
      success: true
    },
    update: {
      loading: false,
      success: true
    }
  },
  banks: {
    add: {
      loading: false,
      success: true
    },
    delete: {}
  },
  cloudPrintUserName: {
    loading: false,
    success: true
  },
  cloudPrintAuthorized: {
    loading: false,
    success: true
  },
  cloudPrint: {
    loading: false,
    success: true
  },
  cardTypes: {
    add: {
      loading: false,
      success: true
    },
    delete: {}
  }
};

export default (state = initialState, action) => {
  const { tagName, settingName, response } = action;
  switch (action.type) {
    case types.START_ADD_TAG:
      return {
        ...state,
        [tagName]: {
          ...state[tagName],
          add: { ...initialState[tagName].add, loading: true }
        }
      };
    case types.ADD_TAG:
      if (
        tagName === TagNames.WithdrawalTypes ||
        tagName === TagNames.DepositSources
      )
        return {
          ...state,
          [tagName]: {
            ...state[tagName],
            add: response.success
              ? {
                  loading: response.loading,
                  success: response.success,
                  data: response.data
                }
              : { loading: response.loading, success: response.success }
          }
        };
      return {
        ...state,
        [tagName]: {
          ...state[tagName],
          add: { loading: response.loading, success: response.success }
        }
      };

    case types.START_UPDATE_TAG:
      return {
        ...state,
        [tagName]: {
          ...state[tagName],
          update: { ...initialState[tagName].update, loading: true }
        }
      };
    case types.UPDATE_TAG:
      return {
        ...state,
        [tagName]: {
          ...state[tagName],
          update: { loading: response.loading, success: response.success }
        }
      };

    case types.START_DELETE_TAG:
      return {
        ...state,
        [tagName]: {
          ...state[tagName],
          delete: {
            ...state[tagName].delete,
            ...{ [action.tagId]: { loading: true } }
          }
        }
      };
    case types.DELETE_TAG:
      const deleteObj = { ...state[tagName].delete };
      response.success
        ? delete deleteObj[action.tagId]
        : (deleteObj[action.tagId] = {
            loading: false,
            success: false,
            message: response.message
          });
      return { ...state, [tagName]: { ...state[tagName], delete: deleteObj } };

    case types.START_UPDATE_SETTING:
      // Hack for location groups- only tags with editing...
      if (settingName === TagNames.LocationGroups)
        return {
          ...state,
          [settingName]: {
            ...state[settingName],
            update: { ...initialState[settingName].update, loading: true }
          }
        };
      return {
        ...state,
        [settingName]: { ...initialState[settingName], loading: true }
      };
    case types.UPDATE_SETTING:
      if (settingName === TagNames.LocationGroups)
        return {
          ...state,
          [settingName]: { ...state[settingName], update: { ...response } }
        };
      return { ...state, [settingName]: { ...response } };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/SystemSettingsReducer.js